/**
 * Pill-less bordered qty stepper from the cart design (− 24 +). When `onSet` is
 * provided the number is click-to-type (direct entry, Enter/blur commit, Esc
 * cancels) — see sizepaper/QtyStepper's shared QtyValue.
 */

import { QtyValue } from '../sizepaper/QtyStepper';

export function QtyStepper({
  value,
  onInc,
  onDec,
  decDisabled,
  label,
  onSet,
  min = 1,
  max = 999,
}: {
  value: number;
  onInc: () => void;
  onDec: () => void;
  decDisabled?: boolean;
  label: string;
  /** Direct-entry commit (clamped to [min, max]); omit for buttons-only. */
  onSet?: (next: number) => void;
  min?: number;
  max?: number;
}) {
  return (
    <span className="qty" role="group" aria-label={`Quantity, ${label}`}>
      <button
        type="button"
        className="qty__btn"
        onClick={onDec}
        disabled={decDisabled}
        aria-label={`Remove one, ${label}`}
      >
        −
      </button>
      {onSet ? (
        <QtyValue
          value={value}
          min={min}
          max={max}
          onCommit={onSet}
          ariaLabel={`Quantity, ${label}`}
          className="qty__num"
        />
      ) : (
        <span className="qty__num" aria-live="polite">
          {value}
        </span>
      )}
      <button type="button" className="qty__btn" onClick={onInc} aria-label={`Add one, ${label}`}>
        +
      </button>
    </span>
  );
}
